import isEqual from 'lodash/isEqual'
import isFunc from 'lodash/isFunction'
import isObject from 'lodash/isObject'
import isUndefined from 'lodash/isUndefined'
import { getCommonConfig } from './propCommonConfig'
// 提取field属性关联的配置项
const getCustomFieldConfig = (chart_config) => {
  const fieldConfigs = {}
  if (!chart_config) return fieldConfigs

  for (let i = 0; i < chart_config.length; i++) {
    const group = chart_config[i]
    if (!group.field) continue
    fieldConfigs[group.field] = {}
    if (group.spread !== undefined) {
      fieldConfigs[group.field].spread = group.spread
    }

    if (group.show !== undefined) {
      fieldConfigs[group.field].show = group.show
    }

    if (!group || !Array.isArray(group.items) || group.items.length <= 0) continue
    for (let j = 0; j < group.items.length; j++) {
      const item = group.items[j]
      if (!item.field) continue

      if (item.field) {
        fieldConfigs[group.field][item.field] = (item.data !== undefined) ? item.data : null
      }

      // if (item.spread !== undefined) {
      //   fieldConfigs[group.field][item.field].spread = item.spread
      // }

      if ((!item.show || !item.show.field) && (!Array.isArray(item.items) || item.items.length <= 0)) continue

      const itemConfig = fieldConfigs[group.field][item.field]
      if (!itemConfig) {
        fieldConfigs[group.field][item.field] = {}
      }

      if (item.show && item.show.field) {
        fieldConfigs[group.field][item.field][item.show.field] = (item.show.data !== undefined) ? item.show.data : null
      }

      if (item.items && item.items.length > 0) {
        for (let k = 0; k < item.items.length; k++) {
          const subItem = item.items[k]
          if (!subItem.field) continue
          fieldConfigs[group.field][item.field][subItem.field] = (subItem.data !== undefined) ? subItem.data : null
        }
      }
    }
  }
  return fieldConfigs
}

// 提取scope属性关联的配置项
const getCustomScopeConfig = (chart_config) => {
  const scopeConfigs = {}
  for (let i = 0; i < chart_config.length; i++) {
    const group = chart_config[i]
    if (group.scope) {
      scopeConfigs[group.scope] = {
        show: group.show
      }
    }

    if (!group || !Array.isArray(group.items) || group.items.length <= 0) continue
    for (let j = 0; j < group.items.length; j++) {
      const item = group.items[j]
      if (item && item.scope) {
        if (item.component) delete item.component
        scopeConfigs[item.scope] = {
          ...item
        }
      }

      if (!item || !Array.isArray(item.items) || item.items.length <= 0) continue
      for (let k = 0; k < item.items.length; k++) {
        const subItem = item.items[k]
        if (subItem && subItem.scope) {
          if (subItem.component) delete subItem.component
          scopeConfigs[subItem.scope] = {
            ...subItem
          }
        }
      }
    }
  }
  return scopeConfigs
}

// 提取配置项的数据（不包含component属性）
function _cleanItem(item) {
  const { field, label, data, scope, show, ref, refVal, items, theme_controled, immutable, spread, tip } = item
  const dataItem = { field, label }
  if (data !== undefined) { dataItem.data = typeof data === 'function' ? data() : data }
  if (scope !== undefined) { dataItem.scope = scope }
  if (show !== undefined) { dataItem.show = show }
  if (ref !== undefined) { dataItem.ref = ref }
  if (refVal !== undefined) { dataItem.refVal = refVal }
  if (theme_controled !== undefined) { dataItem.theme_controled = theme_controled }
  if (items !== undefined) {
    const dataItems = items && items.map(subItem => _cleanItem(subItem))
    dataItem.items = dataItems
  }
  if (spread !== undefined) {
    dataItem.spread = spread
  }
  if (immutable !== undefined) {
    dataItem.immutable = immutable
  }
  if (tip !== undefined) {
    dataItem.tip = tip
  }
  return dataItem
}

const getCustomConfigData = chart_config => chart_config && chart_config.map(group => ({
  ...group,
  items: (group.items && group.items.map(item => _cleanItem(item))) || []
}))

// 如果配置数据与组件配置项版本不一致，则升级配置数据
function _fillConfigData(fieldData, designerChartConfig) {
  const config = designerChartConfig || []
  if (!Array.isArray(config) || config.length <= 0) return config

  const newConfig = [...config]
  for (let i = 0; i < newConfig.length; i++) {
    const group = newConfig[i]
    if (group && group.field && fieldData && fieldData[group.field]) {
      if (fieldData[group.field].spread !== undefined) {
        group.spread = fieldData[group.field].spread
      }

      if (fieldData[group.field].show !== undefined) {
        group.show = fieldData[group.field].show
      }
    }

    if (!group || !Array.isArray(group.items) || group.items.length <= 0) continue
    for (let j = 0; j < group.items.length; j++) {
      const item = group.items[j]
      if (!item || !fieldData) continue
      if (fieldData[group.field] && fieldData[group.field][item.field] !== undefined) {
        item.data = fieldData[group.field][item.field]
      } else if (item.immutable !== undefined) {
        // 如果新增的默认配置会对原有的报告产生影响，可以提供 immutable 属性
        // 当获取客户配置没有该配置项时，使用默认的 immutable 属性
        item.data = isFunc(item.immutable) ? item.immutable(fieldData) : item.immutable
      }

      const { show } = item
      const { field } = show || {}
      if (field && fieldData[group.field] && fieldData[group.field][item.field] && fieldData[group.field][item.field][item.show.field] !== undefined) {
        item.show.data = fieldData[group.field][item.field][item.show.field]
      } else if (field && fieldData[group.field] && fieldData[group.field][item.field] && fieldData[group.field][item.field].spread !== undefined) {
        item.spread = fieldData[group.field][item.field].spread
      } else if (field && item.show.immutable  !== undefined) {
        item.show.data = isFunc(item.show.immutable) ? item.show.immutable(fieldData) : item.show.immutable
      }

      if (item.items && item.items.length > 0) {
        for (let k = 0; k < item.items.length; k++) {
          const subItem = item.items[k]
          const subField = subItem && subItem.field
          if (subField && fieldData[group.field] && fieldData[group.field][item.field] && fieldData[group.field][item.field][subItem.field] !== undefined) {
            subItem.data = fieldData[group.field][item.field][subItem.field]
          } else if (subField && subItem.immutable !== undefined) {
            subItem.data = isFunc(subItem.immutable) ? subItem.immutable(fieldData) : subItem.immutable
          }
        }
      }
    }
  }
  return newConfig
}

const getMergedCustomConfigData = (chartConfigData, designerChartConfigData) => {
  let mergeData
  if (isEqual(chartConfigData, designerChartConfigData)) {
    mergeData = chartConfigData
  } else {
    const chartConfigFieldData = getCustomFieldConfig(chartConfigData)
    mergeData = _fillConfigData(chartConfigFieldData, designerChartConfigData)
  }
  return mergeData
}

// 根据filed获取属性组件
const getPropComponentByField = (chart_config, field, subField) => {
  let propComponent = null
  for (let i = 0; i < chart_config.length; i++) {
    const group = chart_config[i]
    if (!group || !Array.isArray(group.items)) continue

    for (let j = 0; j < group.items.length; j++) {
      const item = group.items[j]
      if (item.field !== field) continue
      if (!subField) {
        propComponent = item.component && item.component.props ? item.component.component : item.component
        propComponent && (propComponent.__PROPS = item.component && item.component.props ? item.component.props : null)
        propComponent && (propComponent.__CONFIG = item)
      } else if (item.items) {
        for (let k = 0; k < item.items.length; k++) {
          const subItem = item.items[k]
          if (subItem.field === subField) {
            propComponent = subItem.component && subItem.component.props ? subItem.component.component : subItem.component
            propComponent && (propComponent.__PROPS = subItem.component && subItem.component.props ? subItem.component.props : null)
            propComponent && (propComponent.__CONFIG = subItem)
            break
          }
        }
      }
      if (propComponent) break
    }
    if (propComponent) break
  }

  return propComponent
}


/**
 *  合并图表通用配置
 *  @param {array} customConfig - 单图的样式配置
 *  @param {string} chartCode - 单图code
 *  @param {string} name - 单图名称
 * @param penetrateName
 */
const concatCommonConfig = (customConfig, chartCode, name, penetrateName) => {
  const commonConfig = getCommonConfig(chartCode, customConfig, name, penetrateName)
  const _customConfig = customConfig && customConfig.filter(config => config.disabled !== true)
  return _customConfig ? _customConfig.concat(commonConfig) : commonConfig
}

// 获取多级field的值, obj('a.b.c')=> obj[a][b][c]
const getFieldValByStrKeys = (obj, strkeys) => {
  const keys = strkeys.split('.')
  let val = null
  keys && keys.forEach((key) => {
    val = obj[key]
    obj = val
  })
  return val
}

const updateEffectValue = (data, list, effectValue) => {
  if (!isObject(list) || !Array.isArray(data)) return

  const effectList = { ...list }

  const awk = (fields, path = '') => {
    if (!Array.isArray(fields)) return
    if (Object.entries(effectList).length <= 0) return

    fields.forEach((d) => {
      const { field, data: fieldData, items } = d
      if (!field) return
      const currentPath = path ? `${path}.${field}` : field

      const effect = effectList[currentPath]
      if (!isUndefined(fieldData) && !isUndefined(effect)) {
        d.data = isFunc(effect) ? effect(effectValue, fieldData) : effect
        Reflect.deleteProperty(effectList, currentPath)
      }

      if (Array.isArray(items)) {
        awk(items, currentPath)
      }
    })
  }

  awk(data)
}

export {
  getCustomFieldConfig,
  getCustomScopeConfig,
  getCustomConfigData,
  getMergedCustomConfigData,
  getPropComponentByField,
  concatCommonConfig,
  getFieldValByStrKeys,
  updateEffectValue,
}
